import React from 'react';
import moment from 'moment'


const PurchaseOrderCreateLabelHeader = ({purchaseOrder, purchaseOrderItem, handleBack, handleChangeMode}) => {

  const scanned = purchaseOrderItem.labels.filter(e => e.barcode !== null).length
  const manually_added = purchaseOrderItem.labels.filter(e => e.barcode === null).reduce((partial_sum, label) => partial_sum + label.number_inventories, 0);

  return (
    <div className="card">
      <div className="row">
        <div className="col-sm-12">
          <div className="card-header-grey d-flex justify-content-between align-items-center">
            <h4 className="pr-1 font-weight-medium no-margin-bottom">Purchase Order #{purchaseOrder.id}</h4>
            <div className='closeStyle'>
              {purchaseOrderItem.has_info_barcodes && <button className='btn btn-info' onClick={() => handleChangeMode(purchaseOrderItem)}><i class="fa fa-exchange" aria-hidden="true"></i></button>}
              <button className='btn btn-danger' onClick={() => handleBack()}>X</button>
            </div>
          </div>
        </div>
      </div>
      <div className="card-block overflow-scroll">
        <div className="row pt-2">
          <div className="col-sm-3">
            <h5>Vendor</h5>
            <p>{purchaseOrder.vendor.name}</p>
          </div>
          <div className="col-sm-3">
            <h5>Delivery date</h5>
            <p>{moment(purchaseOrder.delivery_date).format("L") || ' - '}</p>
          </div>
          <div className="col-sm-3">
            <h5>Date</h5>
            <p>{moment(purchaseOrder.date).format("L") || ' - '}</p>
          </div>
          <div className="col-sm-12">
            <h5>Labels already created</h5>
            <p>Sanned: {scanned} - Manually: {manually_added} </p>
          </div>
        </div>
        <table className="table table-striped table-order-station datatable mb-0">
          <thead className="thead-inverse">
            <tr>
              <th>Item</th>
              <th>Station</th>
              <th>Pieces</th>
              <th>Temperature</th>
              <th>Unit Price</th>
              <th>Qty</th>
              <th className="hidden-xs-down">Manufacturer</th>
              <th className="hidden-xs-down">Grade</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{purchaseOrderItem.name}</td>
              <td>{purchaseOrderItem.station}</td>
              <td>{purchaseOrderItem.number_items}</td>
              <td>{purchaseOrderItem.temperature}</td>
              <td>{purchaseOrderItem.price}</td>
              <td>{purchaseOrderItem.quantity}</td>
              <td className="hidden-xs-down">{purchaseOrderItem.brand ? purchaseOrderItem.brand.brand_name : ' - '}</td>
              <td className="hidden-xs-down">{purchaseOrderItem.grade ? purchaseOrderItem.grade.grade : ' - '}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default PurchaseOrderCreateLabelHeader